import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "HeartButtonstyle__Container",
  componentId: "sc-1l5mlh3-0"
})(["", " img{", "}background-color:", ";border-color:", ";@media (max-width:", "){", "}"], {
  "display": "flex",
  "height": "3rem",
  "width": "3rem",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "padding": "0px",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "aspectRatio": "1 / 1 !important",
  "height": "1.5rem",
  "width": "1.5rem"
}, ({
  $isLike,
  theme
}) => $isLike ? theme.colors.primary[50] : 'transparent', ({
  $isLike,
  theme
}) => $isLike ? theme.colors.primary[50] : theme.colors.grey[20], ({
  theme
}) => theme.breakpoint.md, {
  "height": "2.5rem",
  "width": "2.5rem"
});